// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table__row td{padding:0}.el-table__body tr.current-row>td{background-color:#5c6282!important;color:#f19944}.el-table--enable-row-hover .el-table__body tr:hover>td{background-color:#5c6282;color:#f19944}", ""]);
// Exports
module.exports = exports;
